import smoothscroll from 'smoothscroll-polyfill'
import './scripts/vue'
import './scripts/size-guide'
import './scripts/main-feature'

smoothscroll.polyfill()
